<div class="document-dialog" #resizable cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="dialog-body" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px">
        <!-- ESQUERDA -->
        <div class="editor-column" fxFlex="calc(72% - 12px)" fxFlex.lt-lg="calc(65% - 12px)" fxFlex.lt-md="100"
            fxLayout="column">
            <!-- TOPO -->
            <div class="editor-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
                <div class="drag-handle" cdkDragHandle fxHide.lt-md>
                    <svg width="24" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </div>

                <div class="editor-title-wrap" fxFlex>
                    <h1 class="dialog-title">
                        {{ data.nameDocument }} {{ date | date:'dd/MM/yyyy' }}
                    </h1>
                    <h2 class="dialog-subtitle">
                        {{ data.patient?.person?.name }}
                    </h2>
                </div>

                <button mat-raised-button color="accent" (click)="closeModal()" fxHide.gt-sm>
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <!-- MODELOS -->
            <div class="models-block">
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Modelos de {{ data.nameDocument }}</mat-label>
                    <input matInput [matAutocomplete]="autoModels" [formControl]="modelsControl" placeholder="Modelo"
                        type="search" />
                    <mat-autocomplete #autoModels="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let model of modelsList" [value]="model" [title]="model.title">
                            {{ model.title }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- EDITOR -->
            <div class="editor-content">
                <ng-container *ngIf="document.format == 'docx' || document.format == 'rtf'; else htmlEditor">
                    <div class="office-container">
                        <div id="docx" *ngIf="document.format == 'docx'"></div>
                    </div>
                </ng-container>

                <ng-template #htmlEditor>
                    <div class="quill-container" [class.quill-fullscreen-wrapper]="quillFullscreen">
                        <button mat-icon-button type="button" class="quill-fullscreen-button"
                            (click)="toggleQuillFullscreen($event)"
                            [title]="quillFullscreen ? 'Voltar ao normal' : 'Expandir editor'">
                            <mat-icon>{{ quillFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                        </button>

                        <quill-editor #quill id="quill" class="full-editor" [modules]="configEditor"
                            [formControl]="documentForm" format="html" [placeholder]="data.nameDocument">
                        </quill-editor>
                    </div>
                </ng-template>
            </div>

            <!-- AÇÕES -->
            <div class="actions-row" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="center center"
                fxLayoutGap="12px">

                <button *ngIf="document.id" mat-raised-button color="accent" [disabled]="isButtonDisabled"
                    (click)="newDocument()">
                    <mat-icon>add</mat-icon> Novo
                </button>

                <button mat-raised-button color="warn" (click)="closeModal()" class="action-btn">
                    <mat-icon>close</mat-icon>
                    Cancelar
                </button>

                <button mat-raised-button color="primary" *ngIf="document.format == 'html'"
                    (click)="insert('html', null)" class="action-btn">
                    <mat-icon>save</mat-icon>
                    Salvar
                </button>

                <button mat-raised-button color="primary" (click)="printItem()" [disabled]="isButtonDisabled"
                    *ngIf="document.id" class="action-btn">
                    <mat-icon>print</mat-icon>
                    Imprimir
                </button>
            </div>
        </div>

        <!-- DIREITA -->
        <div class="history-column" fxFlex="calc(28% - 12px)" fxFlex.lt-lg="calc(35% - 12px)" fxFlex.lt-md="100"
            fxLayout="column">
            <div class="history-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="12px">
                <h1 class="history-title">
                    Histórico de {{ data.nameDocument }}
                </h1>

                <button mat-raised-button color="accent" (click)="closeModal()" title="Fechar" fxShow.gt-sm>
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="history-list">
                <mat-accordion class="full-width">
                    <mat-expansion-panel class="expasion-documents"
                        *ngFor="let item of data.documentList; let i = index" (opened)="openPanel(item, i)"
                        (closed)="closedPanel(item)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="panel-row" fxLayout="row" fxLayoutAlign="space-between center"
                                    fxLayoutGap="8px">
                                    <div class="panel-date" fxLayout="row" fxLayoutAlign="start center"
                                        fxLayoutGap="8px">
                                        <mat-icon>today</mat-icon>
                                        <b>
                                            {{ item.dateAt == null ? '---' : (item.dateAt | date:'dd/MM/yyyy') }}
                                        </b>
                                    </div>

                                    <div>
                                        <button mat-icon-button color="accent" title="Visualizar"
                                            (click)="viewDocument($event, item)" [disabled]="document.editing == false">
                                            <mat-icon>search</mat-icon>
                                        </button>

                                        <button mat-icon-button color="accent" title="Deletar"
                                            (click)="deleteDocument(item.id, $event)"
                                            *ngIf="typeDocument != 14 && typeDocument != 5"
                                            [disabled]="item.editing == false">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>

                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="history-preview">
                            <ngx-extended-pdf-viewer
                                *ngIf="(item.format == 'docx' || item.format == 'rtf') && selectedIndex == i && pdfSrc != null"
                                [src]="pdfSrc" [showUnverifiedSignatures]="true" [showHandToolButton]="true"
                                [handTool]="false" [contextMenuAllowed]="false" [showSidebarButton]="false"
                                [showPropertiesButton]="false" [useBrowserLocale]="true" height="45vh" [zoom]="zoom">
                            </ngx-extended-pdf-viewer>

                            <quill-editor *ngIf="item.format == 'html' || item.format == 'txt'"
                                [modules]="{ toolbar: [] }" format="html" [ngStyle]="{ 'height.px': getHeight() }"
                                [ngModel]="result" [readOnly]="true">
                            </quill-editor>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <div class="history-paginator">
                <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                    [pageSizeOptions]="[10]" (page)="getDocuments($event, 'page')">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
